import { render, staticRenderFns } from "./RelacionarContent.vue?vue&type=template&id=c6a07ee0&"
import script from "./RelacionarContent.vue?vue&type=script&lang=js&"
export * from "./RelacionarContent.vue?vue&type=script&lang=js&"
import style0 from "./RelacionarContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports